import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  calendar: {
    maxHeight: '450px',
    overflowY: 'scroll',
  },
  modalContent: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  modalText: {
    color: theme.palette.tertiary.main,
    fontSize: 24,
    fontStyle: 'italic',
    fontWeight: '300',
  },
  primaryText: {
    color: theme.palette.primary.main,
  },
}));
